/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import { useAuth } from '../context'
import { Route, RouteProps, Redirect } from 'react-router-dom'
import { Routes } from '@src/constants'

interface RequireAuth {
  withoutRedirect?: boolean
}

const RequireAuth = ({
  children,
  withoutRedirect
}: React.PropsWithChildren<RequireAuth>) => {
  const { isAuthenticated, pending } = useAuth()

  if (!isAuthenticated()) {
    if (pending?.handleAuthentication || withoutRedirect) {
      return null
    }
    return (
      <Redirect
        to={{
          pathname: Routes.loginPage,
          search: window.location.search
        }}
      />
    )
  }

  return <>{children}</>
}

export const useRequireAuth =
  <Props extends { withoutRedirect?: boolean }>(
    Component: React.ComponentType<Props>,
    ownProps = {}
  ) =>
  (props: Props) => {
    React.useEffect(() => {}, [])
    return (
      <RequireAuth {...ownProps}>
        <Component {...props} />
      </RequireAuth>
    )
  }

export interface SecureRouteProps extends RouteProps, RequireAuth {}

export const SecureRoute = ({ component, ...props }: SecureRouteProps) => {
  const PassedComponent = component ? useRequireAuth(component, props) : null
  return (
    <Route
      {...props}
      component={PassedComponent}
      render={
        props.render
          ? own => (
              <RequireAuth withoutRedirect={props.withoutRedirect}>
                {props.render(own)}
              </RequireAuth>
            )
          : undefined
      }
    />
  )
}
